import axios from 'axios';
import { omit } from 'lodash';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';

const useUpdateProjectModule = () => {
  const { mutateAsync, isLoading } = useMutation(async ({ module, projectId }) => {
    return await axios.patch(`/standardization/${projectId}/modules/${module.id}`, module);
  });

  const updateModule = async (module, projectId, options) => {
    const _module = omit(module, ['referenceModuleImageId']);
    mutateAsync(
      { module: _module, projectId },
      {
        onSuccess: (res) => {
          if (!options.hideNotifications) {
            toast.success(`Successfully updated the module with tag '${res.data.tsCode}'!`);
          }
          options?.onSuccess && options?.onSuccess(res.data);
        },
      }
    );
  };

  return {
    updateModule,
    isLoading,
  };
};

export default useUpdateProjectModule;
